import { render, staticRenderFns } from "./edit-validate.vue?vue&type=template&id=0cc93e88"
import script from "./edit-validate.vue?vue&type=script&lang=js"
export * from "./edit-validate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports